module.exports = __webpack_public_path__ + "assets/LogoGameScreen.104c8048d2661c885ec99a0b0e565ef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/logo/LogoGameScreen.png
// module id = 752
// module chunks = 0